import React from 'react';
import { FileText } from 'lucide-react';
import { Card, Button, Spinner } from '../design-system';
import NoteCard from './NoteCard';

const NotesList = ({ notes, loading, onNoteClick, onCreateNew }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spinner size="medium" />
      </div>
    );
  }

  if (!notes || notes.length === 0) {
    return (
      <Card variant="default" padding="large">
        <div className="text-center py-8">
          <div className="h-16 w-16 rounded-full flex items-center justify-center mx-auto mb-4" style={{backgroundColor: 'rgba(44, 166, 164, 0.1)'}}>
            <FileText className="h-8 w-8" style={{color: 'var(--color-primary)'}} />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-2">No notes yet</h3>
          <p className="text-sm text-gray-600 mb-4">Create your first note to get started</p>
          <Button onClick={onCreateNew} variant="primary" size="medium">
            Create Note
          </Button>
        </div>
      </Card>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {notes.map((note) => (
        <NoteCard
          key={note.noteId}
          note={note}
          onClick={() => onNoteClick(note)}
        />
      ))}
    </div>
  );
};

export default NotesList;

